import { createFileRoute } from '@tanstack/react-router';
import { ServicoList } from '@/features/servico/page/list/ServicoList';

export const Route = createFileRoute('/a/servico/')({
    component: ServicoList,
});
